import { chakra } from "@chakra-ui/react"

// If you want to create a custom Button component, you can use chakra.button and pass theme props as needed.
// However, Chakra's built-in Button will already use the theme if you set it up in extendTheme.
// If this file is not needed, you can remove it and use Chakra's Button directly.

export const Button = chakra("button")